<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="60%"
  >
    <div class="enterprise-member-container">
      <div class="header" style="margin-bottom: 10px;">
        <el-input placeholder="请输入手机号码" v-model.trim="panelPhoneNumber">
          <el-button slot="append" icon="plus" :loadingSubmit="loadingSubmit" :disabled="loadingSubmit" @click="addMember">添加成员</el-button>
        </el-input>
      </div>
      <el-table
        border
        size="mini"
        :data="memberList"
        v-loading="loading"
        style="width: 100%;height: calc(100% - 40px);overflow-y: auto;"
      >
        <el-table-column prop="name" label="会员名称"/>
        <el-table-column prop="mobilePhone" label="手机号"/>
        <el-table-column prop="name" label="是否为负责人">
          <template slot-scope="{ $index, row }">
            <el-switch
              v-model="row.isManager"
              :active-value="true"
              :inactive-value="false"
              active-color="#049EA3"
              inactive-color="#909399"
              @change="changeIsManager(row, $index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              @click="delEnterpriseMember(row)"
              size="mini"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <!--<el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">确 定</el-button>-->
      <el-button @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { enterpriseInfo as getInfo, addEnterpriseMember, delEnterpriseMember, setManagerEnterpriseMember as setManager } from 'api/request'
  export default {
    data() {
      return {
        title: '编辑战略合伙人成员',
        visible: false,
        loading: false,
        loadingSubmit: false,
        enterpriseId: undefined,
        panelPhoneNumber: undefined,
        enterpriseMemberList: [],
        memberList: []
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          this.close()
        }
      },
    },
    methods: {
      show(data) {
        this.visible = true
        const { enterpriseId } = data
        this.enterpriseId = enterpriseId
        this.getInfo(enterpriseId)
      },
      async getInfo(id) {
        this.loading = true
        const data = await getInfo(id)
        if (data && data.partners && Array.isArray(data.partners)) {
          this.memberList = data.partners
        }
        this.loading = false
      },
      submitForm() {
 
      },
      addMember() {
        if (!this.panelPhoneNumber) {
          this.$message.error('请输入手机号码')
          return
        }
        let params = {
          enterpriseId: this.enterpriseId,
          panelPhoneNumber: this.panelPhoneNumber
        }
        this.loadingSubmit = true
        addEnterpriseMember(params).then(res => {
          this.loadingSubmit = false
          if (res) {
            this.$message.success('操作成功')
            this.loadingSubmit = false
            this.getInfo(this.enterpriseId)
          } else {
            this.loadingSubmit = false
          }
        }).finally(() => {
          this.loadingSubmit = false
        })
      },
      delEnterpriseMember(row) {
        const that = this
        that.$confirm(
          `是否确定删除改战略合伙人成员?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          that.loading = true
          delEnterpriseMember({enterpriseId: that.enterpriseId, panelId: row.id }).then(data => {
            that.loading = false
            if (data) {
              that.$message.success('已成功删除')
              that.getInfo(that.enterpriseId)
            }
          }).finally(() => {
            that.loading = false
          })
        }).catch(() => {})
      },
      changeIsManager(row, index) {
        this.loading = true
        setManager({enterpriseId: this.enterpriseId, panelId: row.id, isManager: row.isManager}).then(data => {
          if (data) {
            this.$message.success('设置成功')
            this.$set(row, 'isManager', row.isManager)
            this.$set(this.memberList, index, row)
          } else {
            this.$message.error('设置失败')
            this.$set(row, 'isManager', !row.isManager)
            this.$set(this.memberList, index, row)
          }
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      },
      /*取消*/
      close () {
        this.$emit('done')
        Object.assign(this.$data, this.$options.data.call(this))
      },
    }
  }
</script>

<style lang="scss">
  .enterprise-member-container{
    width: 100%;
    height: 400px;
  }
</style>
